import { createSelector } from 'reselect';
import { RootState } from '../../reducer';

const favoriteSelector = (state: RootState) => state.favorite;

export const favoriteBrandsSelector = createSelector(
  favoriteSelector,
  (favorite) => favorite.favoriteBrands
);

export const makeFavoriteBrandSelector = (brandId: string) =>
  createSelector(
    favoriteBrandsSelector,
    (favorites) =>
      favorites.find(({ brand }) => brand.id === brandId) ?? undefined
  );
